export default {
  summary: 'Summary',
  GeneralSummary: 'General data',
  invoiceId: 'Series and number',
  format: 'Original format',
  created: 'Created',
  onlySupplied: 'Only expenses invoice',
  ContactsSummary: 'Partner data',
  provider: 'Provider data',
  client: `Client's data`,
  agent: 'Agent data',
  customer: 'Customer data',
  DetailsSummary: 'Invoice details',
  AmountsSummary: 'Total amounts.',
  FileSummary: 'Attached files',
  title: 'Total amounts',
  totalGross: 'Total tax base',
  totalDisc: 'Total discounts/global charges',
  totalTaxes: 'Total taxes',
  totalOthers: 'Total payments on account, reimbursable expenses and other',
  total: 'TOTAL',
  concept: 'Concept',
  RequestFactoring: 'Financing',
  requestFactoringTitle: 'Request financing with:',
  selectOption: 'Please select an option',
  legal: 'I agree with the financing conditions',
  legalTextHeader: 'In order to process the financing request you must agree that the following data will be sent to the financing company:',
  conditions: {
    title: 'Conditions to being financiation approved',
    error: `Conditions aren't accomplished to apply for financing`
  },
  mandatory: 'Financial mandatory information'
}
